import {requestMs} from "@helpers/api";

export const reporting = {
  getReports: params => requestMs.get(`/api3/reporting/${params.date}`),
  updateReportConstants: params => requestMs.put(`/api3/reporting/constants`, params.data),
};
